import script from "./CameraModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CameraModal.vue?vue&type=script&setup=true&lang=js"

import "./CameraModal.vue?vue&type=style&index=0&id=4caf484e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4caf484e"]])

export default __exports__